// Same rules as the back office's server-side search (leadrs-back services/adminSearch.ts), for the
// lists filtered in the browser: case and accents ignored, every word must appear somewhere.
const normalize = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const textMatches = (search: string, values: unknown[]): boolean => {
    const words = normalize(search).split(/\s+/).filter(Boolean);
    if (!words.length) return true;
    const haystack = values.filter((v) => v != null && v !== '').map((v) => normalize(String(v)));
    return words.every((word) => haystack.some((value) => value.includes(word)));
};
